import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class ParseAthleticMatchesModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loadingSeasons", true);
    _defineProperty(this, "loadingAnalysis", false);
    _defineProperty(this, "executing", false);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "selectedSeasonId", '');
    _defineProperty(this, "seasonSlug", '');
    _defineProperty(this, "analysisResults", null);
    _defineProperty(this, "error", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadSeasons();
  }
  className() {
    return 'ParseAthleticMatchesModal Modal--large';
  }
  title() {
    return 'Importar partidos desde Athletic Club';
  }
  loadSeasons() {
    this.loadingSeasons = true;
    this.error = null;
    m.redraw();
    app.request({
      method: 'GET',
      url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/seasons")
    }).then(response => {
      this.seasons = response.data || [];
      if (this.seasons.length > 0) {
        const targetSeason = this.seasons.find(s => s.attributes.name.includes('2026-2027')) || this.seasons[0];
        this.selectedSeasonId = targetSeason.id;
        this.updateSlugFromSeason(targetSeason.attributes.name);
      }
      this.loadingSeasons = false;
      m.redraw();
    }).catch(err => {
      console.error('Error loading seasons:', err);
      this.error = 'No se pudieron cargar las temporadas desde la base de datos.';
      this.loadingSeasons = false;
      m.redraw();
    });
  }
  updateSlugFromSeason(name) {
    const match = name.match(/(\d{4})[-/](\d{4})/);
    if (match) {
      this.seasonSlug = "".concat(match[1], "-").concat(match[2].substring(2));
    } else {
      this.seasonSlug = name;
    }
  }
  onSeasonChange(e) {
    this.selectedSeasonId = e.target.value;
    const season = this.seasons.find(s => s.id === this.selectedSeasonId);
    if (season) {
      this.updateSlugFromSeason(season.attributes.name);
    }
  }
  analyzeMatches() {
    if (!this.selectedSeasonId || !this.seasonSlug) return;
    this.loadingAnalysis = true;
    this.analysisResults = null;
    this.error = null;
    m.redraw();
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/matches/parse-athletic"),
      body: {
        season_id: this.selectedSeasonId,
        season_slug: this.seasonSlug,
        execute: false
      }
    }).then(response => {
      if (response.success) {
        this.analysisResults = response.results;
      } else {
        this.error = response.error || 'Ocurrió un error inesperado al analizar los partidos.';
      }
      this.loadingAnalysis = false;
      m.redraw();
    }).catch(err => {
      console.error('Error analyzing matches:', err);
      this.error = err.message || 'Error al conectar con el servidor para analizar los partidos.';
      this.loadingAnalysis = false;
      m.redraw();
    });
  }
  confirmImport() {
    if (!this.selectedSeasonId || !this.seasonSlug || !this.analysisResults) return;
    this.executing = true;
    this.error = null;
    m.redraw();
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/matches/parse-athletic"),
      body: {
        season_id: this.selectedSeasonId,
        season_slug: this.seasonSlug,
        execute: true
      }
    }).then(response => {
      this.executing = false;
      if (response.success) {
        const results = response.results;
        const createdCount = results.filter(r => r.status === 'created').length;
        const updatedCount = results.filter(r => r.status === 'updated').length;
        app.alerts.show({
          type: 'success'
        }, "\xA1Importaci\xF3n completada! Se crearon ".concat(createdCount, " partidos y se actualizaron ").concat(updatedCount, "."));
        this.hide();
        window.location.reload();
      } else {
        this.error = response.error || 'Error al ejecutar la importación.';
        m.redraw();
      }
    }).catch(err => {
      console.error('Error executing import:', err);
      this.error = err.message || 'Error al conectar con el servidor para importar los partidos.';
      this.executing = false;
      m.redraw();
    });
  }
  content() {
    if (this.loadingSeasons) {
      return m("div", {
        className: "Modal-body",
        style: {
          textAlign: 'center',
          padding: '40px'
        }
      }, m(LoadingIndicator, null), m("p", {
        style: {
          marginTop: '15px'
        }
      }, "Cargando temporadas disponibles..."));
    }
    if (this.error && !this.analysisResults) {
      return m("div", {
        className: "Modal-body",
        style: {
          padding: '30px',
          textAlign: 'center'
        }
      }, m("div", {
        style: {
          fontSize: '3rem',
          marginBottom: '15px'
        }
      }, "\u26A0\uFE0F"), m("p", {
        style: {
          fontWeight: 'bold',
          color: '#ef4444'
        }
      }, "Error al iniciar la importaci\xF3n"), m("p", null, this.error), m(Button, {
        className: "Button Button--primary",
        onclick: this.loadSeasons.bind(this)
      }, "Reintentar"));
    }
    const url = "https://www.athletic-club.eus/equipos/athletic-club/".concat(this.seasonSlug, "/partidos/");
    return m("div", {
      className: "Modal-body",
      style: {
        padding: '25px'
      }
    }, !this.analysisResults && !this.loadingAnalysis && m("div", {
      className: "ParseMatchesForm",
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }
    }, m("p", {
      style: {
        color: 'var(--muted-color)',
        lineHeight: '1.5'
      }
    }, "Esta herramienta conectar\xE1 con la web oficial del Athletic Club para obtener los partidos de Liga e importarlos o completarlos en la temporada seleccionada."), m("div", {
      className: "Form-group"
    }, m("label", {
      style: {
        fontWeight: 'bold',
        marginBottom: '8px',
        display: 'block'
      }
    }, "Temporada en Flarum:"), m("select", {
      className: "FormControl",
      value: this.selectedSeasonId,
      onchange: this.onSeasonChange.bind(this),
      style: {
        width: '100%',
        borderRadius: '8px'
      }
    }, this.seasons.map(s => m("option", {
      value: s.id
    }, s.attributes.name)))), m("div", {
      className: "Form-group"
    }, m("label", {
      style: {
        fontWeight: 'bold',
        marginBottom: '8px',
        display: 'block'
      }
    }, "Slug de la temporada en la web del Athletic:"), m("input", {
      type: "text",
      className: "FormControl",
      value: this.seasonSlug,
      oninput: e => this.seasonSlug = e.target.value,
      placeholder: "Ej. 2026-27",
      style: {
        width: '100%',
        borderRadius: '8px'
      }
    }), m("p", {
      style: {
        fontSize: '0.85em',
        color: 'var(--muted-color)',
        marginTop: '6px'
      }
    }, "Se consultar\xE1 la direcci\xF3n: ", m("a", {
      href: url,
      target: "_blank",
      rel: "noopener noreferrer",
      style: {
        color: 'var(--link-color)',
        textDecoration: 'underline'
      }
    }, url))), m("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '15px'
      }
    }, m(Button, {
      className: "Button Button--primary",
      onclick: this.analyzeMatches.bind(this),
      style: {
        borderRadius: '8px',
        padding: '10px 20px',
        fontWeight: 'bold'
      }
    }, "Analizar partidos"))), this.loadingAnalysis && m("div", {
      style: {
        textAlign: 'center',
        padding: '40px'
      }
    }, m(LoadingIndicator, null), m("p", {
      style: {
        marginTop: '15px',
        fontWeight: 'bold'
      }
    }, "Conectando y parseando partidos desde athletic-club.eus..."), m("p", {
      style: {
        fontSize: '0.9em',
        color: 'var(--muted-color)'
      }
    }, url)), this.analysisResults && m("div", {
      className: "AnalysisResults",
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }
    }, this.error && m("div", {
      style: {
        background: 'rgba(239, 68, 68, 0.1)',
        border: '1px solid rgba(239, 68, 68, 0.3)',
        padding: '15px',
        borderRadius: '8px',
        color: '#f87171'
      }
    }, m("strong", null, "Error:"), " ", this.error), m("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }
    }, m("h3", {
      style: {
        margin: '0',
        fontWeight: 'bold'
      }
    }, "Resumen de partidos detectados"), m("span", {
      className: "badge",
      style: {
        background: 'rgba(255,255,255,0.08)',
        padding: '5px 10px',
        borderRadius: '12px',
        fontSize: '0.85em'
      }
    }, "Temporada Flarum ID: ", this.selectedSeasonId, " | Web Slug: ", this.seasonSlug)), m("div", {
      style: {
        maxHeight: '400px',
        overflowY: 'auto',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '10px',
        background: 'rgba(0, 0, 0, 0.2)'
      }
    }, m("table", {
      style: {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'left'
      }
    }, m("thead", null, m("tr", {
      style: {
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        background: 'rgba(255, 255, 255, 0.03)'
      }
    }, m("th", {
      style: {
        padding: '12px',
        fontSize: '0.85em',
        textTransform: 'uppercase',
        color: 'var(--muted-color)'
      }
    }, "Jor."), m("th", {
      style: {
        padding: '12px',
        fontSize: '0.85em',
        textTransform: 'uppercase',
        color: 'var(--muted-color)'
      }
    }, "Partido"), m("th", {
      style: {
        padding: '12px',
        fontSize: '0.85em',
        textTransform: 'uppercase',
        color: 'var(--muted-color)'
      }
    }, "Fecha / Hora"), m("th", {
      style: {
        padding: '12px',
        fontSize: '0.85em',
        textTransform: 'uppercase',
        color: 'var(--muted-color)'
      }
    }, "Goles"), m("th", {
      style: {
        padding: '12px',
        fontSize: '0.85em',
        textTransform: 'uppercase',
        color: 'var(--muted-color)'
      }
    }, "Acci\xF3n / Estado"))), m("tbody", null, this.analysisResults.map((match, idx) => {
      let statusColor = 'gray';
      let statusLabel = match.status;
      if (match.status === 'create') {
        statusColor = '#10b981';
        statusLabel = 'Se creará';
      } else if (match.status === 'update') {
        statusColor = '#3b82f6';
        statusLabel = 'Se completará';
      } else if (match.status === 'error') {
        statusColor = '#ef4444';
        statusLabel = 'Error';
      } else if (match.status === 'no_change') {
        statusColor = 'rgba(255,255,255,0.4)';
        statusLabel = 'Sin cambios';
      }
      const formattedDate = match.match_date ? new Date(match.match_date).toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }) : 'No fijada';
      const matchString = match.is_local ? "Athletic Club - ".concat(match.opponent_name) : "".concat(match.opponent_name, " - Athletic Club");
      const scoreString = match.score_athletic !== null ? match.is_local ? "".concat(match.score_athletic, " - ").concat(match.score_opponent) : "".concat(match.score_opponent, " - ").concat(match.score_athletic) : '-';
      return m("tr", {
        key: idx,
        style: {
          borderBottom: '1px solid rgba(255,255,255,0.05)'
        }
      }, m("td", {
        style: {
          padding: '12px',
          fontWeight: 'bold'
        }
      }, match.jornada), m("td", {
        style: {
          padding: '12px'
        }
      }, m("div", null, matchString), match.rival_name_db && m("div", {
        style: {
          fontSize: '0.75em',
          color: '#10b981'
        }
      }, "Rival BD: ", match.rival_name_db)), m("td", {
        style: {
          padding: '12px',
          fontSize: '0.9em',
          color: 'var(--muted-color)'
        }
      }, formattedDate), m("td", {
        style: {
          padding: '12px',
          fontWeight: 'bold',
          color: 'var(--heading-color)'
        }
      }, scoreString), m("td", {
        style: {
          padding: '12px'
        }
      }, m("span", {
        style: {
          display: 'inline-block',
          padding: '3px 8px',
          borderRadius: '6px',
          fontSize: '0.8em',
          fontWeight: 'bold',
          backgroundColor: statusColor + '1c',
          border: '1px solid ' + statusColor,
          color: statusColor
        }
      }, statusLabel), m("div", {
        style: {
          fontSize: '0.75em',
          color: 'var(--muted-color)',
          marginTop: '3px'
        }
      }, match.status_message)));
    })))), m("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItem: 'center',
        padding: '15px',
        borderRadius: '10px',
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.1)'
      }
    }, m("div", {
      style: {
        display: 'flex',
        gap: '15px',
        fontSize: '0.95em'
      }
    }, m("div", null, "\uD83C\uDD95 ", m("strong", {
      style: {
        color: '#10b981'
      }
    }, this.analysisResults.filter(r => r.status === 'create').length), " a crear"), m("div", null, "\uD83D\uDD04 ", m("strong", {
      style: {
        color: '#3b82f6'
      }
    }, this.analysisResults.filter(r => r.status === 'update').length), " a completar"), m("div", null, "\u2705 ", m("strong", {
      style: {
        color: 'var(--muted-color)'
      }
    }, this.analysisResults.filter(r => r.status === 'no_change').length), " al d\xEDa"), m("div", null, "\u274C ", m("strong", {
      style: {
        color: '#ef4444'
      }
    }, this.analysisResults.filter(r => r.status === 'error').length), " con problemas")), m("div", {
      style: {
        display: 'flex',
        gap: '10px'
      }
    }, m(Button, {
      className: "Button",
      onclick: () => {
        this.analysisResults = null;
        this.error = null;
        m.redraw();
      },
      disabled: this.executing
    }, "Volver"), this.analysisResults.some(r => r.status === 'create' || r.status === 'update') && m(Button, {
      className: "Button Button--primary",
      onclick: this.confirmImport.bind(this),
      loading: this.executing,
      disabled: this.executing,
      style: {
        fontWeight: 'bold',
        borderRadius: '8px'
      }
    }, "Confirmar Importaci\xF3n")))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/ParseAthleticMatchesModal', ParseAthleticMatchesModal);